import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgShieldIcon = function SvgShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.904 20.746 16 22.662 22.3 29l9.7-9.01L30.174 18l-7.8 7.244z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.955 13.209c.186 3.992-.18 8.743-1.581 13.365-2.229 7.346-6.662 12.55-13.761 14.277l-.611.149-.61-.149C16.298 39.123 11.863 33.92 9.63 26.575c-1.408-4.631-1.781-9.466-1.58-13.378l.096-1.887L24.002 7l15.864 4.312zm-2.073-.291-13.88-3.773-13.879 3.773c-.176 3.442-.375 22.483 13.88 25.955 14.27-3.472 14.04-22.513 13.879-25.955"
  })));
};

export { SvgShieldIcon as default };
